// YERİ: src/app/domains/website/sections/mkt-roadmap.section.ts
//
// "Sıradaki" — henüz ÜRÜNDE OLMAYAN işler.
//
// Neden ayrı bir bölüm tipi ve neden her kartta bir DURUM ROZETİ var: yol
// haritasını normal özellik bölümleriyle aynı biçimde anlatmak, olmayan bir
// şeyi varmış gibi göstermek olurdu. Ziyaretçi (ve hibe değerlendiricisi)
// bugün ne alacağını, neyin geleceğini bir bakışta ayırt edebilmeli. Rozet
// bezeme değil, sözleşmedir.

import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SiteConfig, cfg } from '@/app/domains/site/sections/section.model';
import { LanguageStore } from '../core/language.store';
import { MktIcon } from './mkt-icon';
import { MktReveal } from './mkt-motion';
import { MktRouterLink, resolveMktLink } from './mkt-link';

interface RoadmapItem {
  icon?: string;
  status?: string;
  title?: string;
  description?: string;
}

@Component({
  selector: 'mkt-roadmap',
  standalone: true,
  imports: [RouterLink, MktIcon, MktReveal],
  host: { class: 'block bg-[color:var(--mkt-ink)] text-white' },
  template: `
    <div class="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">

      <div class="mx-auto max-w-3xl text-center" mktReveal>
        @if (eyebrow()) {
          <p class="mkt-eyebrow justify-center !text-[color:var(--mkt-accent-glow)]">{{ eyebrow() }}</p>
        }
        <!-- Keyfi punto kendi satır yüksekliğini TAŞIMAK ZORUNDA: Tailwind
             text-[2.75rem] yazınca satır yüksekliği GELMEZ, küçük kırılma
             noktasının değeri kalır ve satırlar üst üste biner.
             NOT: bu bir şablon literali — yorumda BACKTICK kullanma, string'i
             erken kapatır ve build'i kırar. -->
        <h2 class="mt-4 text-3xl font-extrabold tracking-tight sm:text-[2.75rem]/[1.18]">{{ title() }}</h2>
        @if (subtitle()) {
          <p class="mt-5 text-lg leading-relaxed text-white/60">{{ subtitle() }}</p>
        }
      </div>

      <ul class="mt-16 grid gap-5 lg:grid-cols-3">
        @for (item of items(); track $index; let i = $index) {
          <li [mktReveal]="i * 70"
            class="flex flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-7">

            <div class="flex items-start justify-between gap-4">
              <span class="grid size-11 place-items-center rounded-xl bg-white/10 text-[color:var(--mkt-accent-glow)]">
                <mkt-icon [name]="item.icon || 'sparkles'" [size]="20" />
              </span>

              @if (item.status) {
                <!-- Durum rozeti: bu bölümün tamamı henüz YOK. Rozeti gizlemek
                     ya da "yeni özellik" gibi göstermek yanıltıcı olurdu. -->
                <span class="rounded-full border border-white/15 px-3 py-1 text-[0.6875rem] font-bold uppercase tracking-wide text-white/50">
                  {{ item.status }}
                </span>
              }
            </div>

            <h3 class="mt-6 text-lg font-bold leading-snug">{{ item.title }}</h3>
            @if (item.description) {
              <p class="mt-3 flex-1 text-[0.9375rem] leading-relaxed text-white/55">{{ item.description }}</p>
            }
          </li>
        }
      </ul>

      @if (ctaText()) {
        <div class="mt-14 text-center" mktReveal>
          <a [routerLink]="link(ctaUrl())"
            class="inline-flex items-center gap-2 text-[0.9375rem] font-bold text-[color:var(--mkt-accent-glow)] transition-all hover:gap-3">
            {{ ctaText() }}
            <mkt-icon name="arrow" [size]="16" />
          </a>
        </div>
      }
    </div>
  `,
})
export class MktRoadmapSection {
  private langStore = inject(LanguageStore);

  readonly config = input.required<SiteConfig>();

  protected eyebrow  = computed(() => cfg(this.config(), 'eyebrow', ''));
  protected title    = computed(() => cfg(this.config(), 'title', ''));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', ''));
  protected ctaText  = computed(() => cfg(this.config(), 'ctaText', ''));
  protected ctaUrl   = computed(() => cfg(this.config(), 'ctaUrl', 'contact'));

  protected items = computed<RoadmapItem[]>(() => {
    const raw = this.config()['items'];
    return Array.isArray(raw) ? raw : [];
  });

  protected link(url?: string): MktRouterLink {
    return resolveMktLink(url ?? '', this.langStore.current());
  }
}
